export default __webpack_public_path__ + "static/media/navbar-sender-orange.f5ddeacb.svg";